/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-10",
    versionChannel: "nightly",
    buildDate: "2025-06-10T00:07:10.659Z",
    commitHash: "18d796ab4718a1142416c36d06eecead81bd7f3c",
};
